import { render, staticRenderFns } from "./GasFutures.vue?vue&type=template&id=d2b16aca"
import script from "./GasFutures.vue?vue&type=script&lang=js"
export * from "./GasFutures.vue?vue&type=script&lang=js"
import style0 from "./GasFutures.vue?vue&type=style&index=0&id=d2b16aca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports